"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EncryptionType = void 0;
/*
 Copied from portis: packages/portis-crypto/src/enums/encryptionType.ts
 */
/* eslint-disable @typescript-eslint/camelcase */
var EncryptionType;
(function (EncryptionType) {
    EncryptionType[EncryptionType["AesCbc256_HmacSha256_B64"] = 2] = "AesCbc256_HmacSha256_B64";
})(EncryptionType = exports.EncryptionType || (exports.EncryptionType = {}));
